import * as React from "react";
import {imageBaseUrl} from "config";
import EGoldHeaderNav from "egold/components/header";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IEgoldUserDetails, IGoldBalance} from "StateInterface";
import {HeaderTitle, renderEmptyMessage, renderProceed} from "egold/utils";
import {useEffect} from "react";
import {getBalance} from "egold/actions";
import {vendor} from "egold/egold-config";
import {handleNavigation, routePaths} from "egold/routes";

interface IConnectProps {
    dispatch?: (action: any) => void;
    goldBalance: IGoldBalance;
    eGoldUserDetails: IEgoldUserDetails;
}
function Locker(props: IConnectProps) {
    useEffect(() => {
        if (props.eGoldUserDetails)
            props.dispatch(getBalance(vendor.SAFEGOLD, props.eGoldUserDetails.vendor_id));
    }, []);
    return (
           <div className="add-margin">
               <EGoldHeaderNav title={HeaderTitle.LOCKER}/>
               {props.goldBalance && Number(props.goldBalance.gold_balance) > 0 ?
                   renderBalanceInfo(props.goldBalance) :
                   renderEmptyMessage(`${imageBaseUrl}/img/locker-image.png`,
                       "No gold balance",
                       "Start buying gold and secure your future",
                   )
               }
           </div>
    );
}

function renderBalanceInfo(balance: IGoldBalance) {
    return(
        <div className={"locker-container mt-4 mx-2"}>
            <div className="d-flex justify-content-between align-items-center px-3 py-2 border rounded">
                <div className="left">
                    <p className="right-text p-0 m-0">24k 99.5% Purity</p>
                    <img className="my-2" src={`${imageBaseUrl}/img/icons/eGold/safegold_logo.svg`} style={{width: "100px"}}/>
                    <br/>
                    <b className="left-text">{balance.gold_balance}gm</b>
                </div>
                <div className="right pr-1">
                    <i className="fa fa-check-circle float-right" style={{color: "green"}} aria-hidden="true"/>
                    <br/><br/>
                    <b className="left-text text-dark">
                        {/*<i className="fa fa-inr price-icon" aria-hidden="true"/>&nbsp;*/}
                        {/*{balance.gold_balance}*/}
                    </b>
                </div>
            </div>

            <div className={"d-flex justify-content-center mt-4 mb-1"}>
                <img className="my-5" src={`${imageBaseUrl}/img/icons/eGold/locker-bg.png`} style={{width: "300px"}}/>
            </div>
            <div className="p-1 text-center">
                <small>Buy more 24K Gold to create long term wealth</small>
            </div>
            <button className="p-2 mt-2 mb-3 eGold-submit-btn"
                    style={{width: "70%", margin: "auto"}}
                    onClick={() => handleNavigation(routePaths.BUY_GOLD)}
            >
                Buy more gold
            </button>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        goldBalance: state.eGold.goldBalance,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(Locker);
